/**
 * Настройки на системата (Раздел 8, екран „Настройки“).
 *
 * Стойностите живеят в таблица `settings` като JSON и се редактират от Админ.
 * Тук са схемата и стойностите по подразбиране — валидацията е една и съща
 * за API-то и за worker-а.
 */
import { z } from 'zod';
import { DEFAULT_FLAG_THRESHOLD } from './scoring.js';
export const SETTING_KEYS = {
    flagThreshold: 'flag_threshold',
    retention: 'retention',
    notifications: 'notifications',
};
export const flagThresholdSchema = z.object({
    /** Обща оценка под този праг маркира разговора като проблемен (Q3: остава 60). */
    value: z.number().int().min(0).max(100),
});
export const retentionSchema = z.object({
    /** Срок за самото аудио, в дни. */
    audioDays: z.number().int().min(1).max(3650),
    /** Срок за транскрипциите и оценките, в дни. */
    dataDays: z.number().int().min(1).max(3650),
});
export const notificationsSchema = z.object({
    /** Получатели на известията при FAILED (Раздел 6). */
    failureRecipients: z.array(z.string().email()),
});
export const DEFAULT_SETTINGS = {
    [SETTING_KEYS.flagThreshold]: { value: DEFAULT_FLAG_THRESHOLD },
    // Стойности по подразбиране до писменото потвърждение на клиента по Q5.
    [SETTING_KEYS.retention]: { audioDays: 180, dataDays: 365 },
    [SETTING_KEYS.notifications]: { failureRecipients: [] },
};
export const settingSchemas = {
    [SETTING_KEYS.flagThreshold]: flagThresholdSchema,
    [SETTING_KEYS.retention]: retentionSchema,
    [SETTING_KEYS.notifications]: notificationsSchema,
};
/** Валидира стойност за даден ключ; хвърля при несъответствие. */
export function parseSetting(key, value) {
    return settingSchemas[key].parse(value);
}
//# sourceMappingURL=settings.js.map